import type { CheckoutEvent as GQLCheckoutEvent } from '../generated/checkout.graphql';
import * as CheckoutConfig from './CheckoutConfig';
import * as CheckoutVenue from './CheckoutVenue';
import * as CheckoutSeatingChartConfig from './CheckoutSeatsioConfig';
import * as AnnounceImage from './AnnounceImage';
import * as CheckoutArtist from './CheckoutArtist';
import { take } from '../util/takePayload';

export type CheckoutEvent = {
  id: number;
  slug: string;
  name: string;
  canonicalUrl?: string;
  promoter?: string;
  support?: string;
  doorTime: string;
  startTime: string;
  endTime?: string;
  footerContent?: string;
  description?: string;
  usesSeatingChart?: boolean;
  minimumAge?: number;
  seatingChartConfig?: CheckoutSeatingChartConfig.SeatsioConfig;
  venue?: CheckoutVenue.CheckoutVenue;
  images?: AnnounceImage.AnnounceImage[];
  config?: CheckoutConfig.CheckoutConfig;
  artists?: CheckoutArtist.CheckoutArtist[];
  showIceBanner?: boolean;
};

export const fromGql = (gqlEvent: GQLCheckoutEvent): CheckoutEvent => {
  return {
    ...(take(
      gqlEvent,
      'id',
      'slug',
      'name',
      'canonicalUrl',
      'promoter',
      'support',
      'doorTime',
      'startTime',
      'endTime',
      'footerContent',
      'description',
      'usesSeatingChart',
      'minimumAge',
      'showIceBanner',
    ) as CheckoutEvent),
    venue: gqlEvent.venue ? CheckoutVenue.fromGql(gqlEvent.venue) : undefined,
    seatingChartConfig: gqlEvent.seatingChartConfig ? CheckoutSeatingChartConfig.fromGql(gqlEvent.seatingChartConfig) : undefined,
    images: AnnounceImage.fromGqlCollection(gqlEvent.images),
    config: gqlEvent.config ? CheckoutConfig.fromGql(gqlEvent.config) : undefined,
    artists: gqlEvent.artists ? CheckoutArtist.fromGqlCollection(gqlEvent.artists) : [],
  };
};
